import { AUTH_TOKEN_COOKIE_KEY } from "constants";
import { getAPIBaseURL } from "utils/env";
import { getCookie } from "utils/cookie";

export async function uploadFile(file) {
  const token = getCookie(AUTH_TOKEN_COOKIE_KEY);

  const presignRes = await fetch(`${getAPIBaseURL()}/s3/presign`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ filename: file.name, contentType: file.type }),
  });

  if (!presignRes.ok) throw new Error(`Presign request failed: ${presignRes.status}`);

  const { url, location } = await presignRes.json().then((r) => r.data);

  const s3Res = await fetch(url, {
    method: "PUT",
    body: file,
    headers: { "Content-Type": file.type },
  });

  if (!s3Res.ok) throw new Error(`S3 upload failed: ${s3Res.status}`);

  return { location };
}
